import { Injectable } from '@angular/core';
import { Http, Response } from '@angular/http';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/do';
import 'rxjs/add/operator/catch';
import 'rxjs/add/operator/map';
import { contentHeaders,APIURL,JsonURL } from '../common/headers';
import { IUsers } from '../database';
import { AuthGuard } from '../common/auth.guard';
import { LoginService  } from '../service';
@Injectable()
export class ProductService {
    private _getProductAllUrl = APIURL+'Product/getAllProduct';
    private _getProductUrl = APIURL+'Product/Product';
    private _isActivelUrl = APIURL+'Product/ProductVerify';
    private _deleteUrl = APIURL+'Product/deleteProduct';
    private _addUrl = APIURL+'Product/saveProduct';
    private _getProductByIdUrl=APIURL+'Product/getProductsById';
    private _editUrl=APIURL+'Product/updateProductById';
    private _addQusUrl=APIURL+'Product/saveQusProduct';
    private _submitProdect=APIURL+'Product/submitProdect';
    private _getProductInfoUrl=APIURL+'Product/getProdectInfo';
    private _isApprovedUrl=APIURL+'Product/ProdectApproved';
    private _isRejectUrl=APIURL+'Product/ProdectReject';
    private _deleteQusUrl=APIURL+'Product/deleteQus';
    private _updateQusUrl=APIURL+'Product/UpdateQus';
    private _commentByIdUrl=APIURL+'Student/getProductInfo';
    private _iconUrl=JsonURL+'data/icon.json';
    constructor(private _http: Http) { 

    }
    getCommentById(ProductId:number):any{
        let formData:FormData = new FormData();
        formData.append('Product', ProductId+"");
       return this._http.post(this._commentByIdUrl,formData )
                           .map((response: Response) => response.json().data)
    }
    getIcon(): any{
       return this._http.post(this._iconUrl,null,null)
                           .map((response: Response) => response.json())
                           .catch(this.handleError);
    }
    getProductInfo(ProductId:number):any{
        let formData:FormData = new FormData();
        formData.append('ProductId', ProductId+"");
       return this._http.post(this._getProductInfoUrl,formData )
                           .map((response: Response) => response.json().data)
    }
    isApproved(ProductId:number,CommentBox:string){
        let formData:FormData = new FormData();
        formData.append('ProductId', ProductId+"");
        formData.append('Comment', CommentBox+"");
       return this._http.post(this._isApprovedUrl,formData )
                           .map((response: Response) => response.json())
    }
    isReject(ProductId:number,CommentBox:string,Qus){
        let formData:FormData = new FormData();
        formData.append('ProductId', ProductId+"");
        formData.append('Comment', CommentBox);
        formData.append('Qus', JSON.stringify(Qus) );
       return this._http.post(this._isRejectUrl,formData )
                           .map((response: Response) => response.json())
    }
    isProductActive(ProductId:string): any{
         let formData:FormData = new FormData();
         formData.append('ProductId', ProductId);
        return this._http.post(this._isActivelUrl,formData )
                            .map((response: Response) => response.json())
                            .catch(this.handleError);
    }
    removedQust(QustionId,ProdectId,statusId){
        let formData:FormData = new FormData();
        formData.append('ProdectId', ProdectId);
        formData.append('QustionId', QustionId);
        formData.append('statusId', statusId);
       return this._http.post(this._deleteQusUrl,formData )
                           .map((response: Response) => response.json())
    }
    getAllPro(){
       return this._http.post(this._getProductAllUrl,null )
                            .map((response: Response) => response.json())
    }
    getPro(userId:any){
         let formData:FormData = new FormData();
         formData.append('userId', userId);
        return this._http.post(this._getProductUrl,formData )
                            .map((response: Response) => response.json())
    }
    getAllProducts(page=null,pageSize=null):any{
        let formData:FormData = new FormData();
         formData.append('page', page);
          formData.append('pageSize', pageSize);
        return this._http.post(this._getProductAllUrl,formData )
                            .map((response: Response) => response.json())
    }
    getProducts(userId:any=null,page=null,pageSize=null): any{
         let formData:FormData = new FormData();
         formData.append('userId', userId);
          formData.append('page', page);
           formData.append('pageSize', pageSize);
        return this._http.post(this._getProductUrl,formData )
                            .map((response: Response) => response.json())
         
    }
    add(form:any,isUNNew,isSubNew,isSemNew,iconStr):any{
        var currentUser = JSON.parse(localStorage.getItem('UserInfo'));
           let formData:FormData = new FormData();
         formData.append('productName', form.productName);
         formData.append('qualification', form.qualification);
         formData.append('Duration', form.Duration);
         formData.append('UniversityId', form.UniversityId);
         formData.append('SubjectId', form.SubjectId);
          formData.append('androidProdId', form.androidProdId);
           formData.append('iosProdId', form.iosProdId);
         formData.append('semesterId', form.semesterId);
         formData.append('disProduct', form.disProduct);
         formData.append('Price', form.Price);
         formData.append('IconName', iconStr);
         formData.append('ExamTime', form.ExamTime);
         formData.append('Chapter', form.Chapter);
         formData.append('userId',currentUser.UserId+"" );
         formData.append('Cheapters', JSON.stringify(form.Cheapters));
            formData.append('isUNNew', isUNNew);
            formData.append('isSubNew', isSubNew);
            formData.append('isSemNew', isSemNew);

        return this._http.post(this._addUrl,formData )
            .map((response: Response) => response.json())
            .catch(this.handleError);
    }
    submitProdect(ProdectId):any{
        let formData:FormData = new FormData();
        formData.append('ProdectId', ProdectId);
       return this._http.post(this._submitProdect,formData )
            .map((response: Response) => response.json())
            .catch(this.handleError);
    }
    QusAdd(form:any,ProdectId):any{
       let formData:FormData = new FormData();
        formData.append('OldQustion', JSON.stringify(form.OldQustion));
        formData.append('ProdectId', ProdectId);
       return this._http.post(this._addQusUrl,formData )
            .map((response: Response) => response.json())
            .catch(this.handleError);
           
    }
    delete(SubjectId): any{
           let formData:FormData = new FormData();
         formData.append('SubjectId',SubjectId);
        return this._http.post(this._deleteUrl,formData )
                            .map((response: Response) => response.json().data)
         
    }
    edit(form:any,isUNNew,isSubNew,isSemNew,iconStr):any{
        var currentUser = JSON.parse(localStorage.getItem('UserInfo'));
           let formData:FormData = new FormData();
           
           formData.append('productId', form.productId);
         formData.append('productName', form.productName);
         formData.append('qualification', form.qualification);
         formData.append('Duration', form.Duration);
         formData.append('UniversityId', form.UniversityId);
         formData.append('SubjectId', form.SubjectId);
          formData.append('androidProdId', form.androidProdId);
           formData.append('iosProdId', form.iosProdId);
         formData.append('semesterId', form.semesterId);
         formData.append('disProduct', form.disProduct);
         formData.append('Price', form.Price);
         formData.append('IconName', iconStr);
         formData.append('ExamTime', form.ExamTime);
         formData.append('Chapter', form.Chapter);
         formData.append('userId', currentUser.UserId+"");
         formData.append('Cheapters', JSON.stringify(form.Cheapters));
            formData.append('isUNNew', isUNNew);
            formData.append('isSubNew', isSubNew);
            formData.append('isSemNew', isSemNew);
         
        return this._http.post(this._editUrl,formData )
            .map((response: Response) => response.json())
            .catch(this.handleError);
    }
    getProductById(Id:any): any{
        let formData:FormData = new FormData();
         formData.append('ProductId', Id);
        return this._http.post(this._getProductByIdUrl,formData )
                            .map((response: Response) => response.json().data)
    }
    private handleError(error: Response) {
        // in a real world app, we may send the server to some remote logging infrastructure
        // instead of just logging it to the console
        console.error(error);
        return Observable.throw(error.json().error || 'Server error');
    }
}


// WEBPACK FOOTER //
// ./src/app/service/product.service.ts